import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { GetServiceCallTempList } from '../API/ServiceCallAPI';
import Loader from './Loader.js';

const ServiceTempList = (props) => {
    const [status, setStatus] = useState(-1);
    const [svcTemps, setSvcTemps] = useState([]);
    //const [canAdd, setCanAdd] = useState(false);
    const [statuses, setStatuses] = useState([]);
    //const [timeUnits, setTimeUnits] = useState([]);
    //const [scheduleUnits, setScheduleUnits] = useState([]);
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        setLoading(true);
        GetServiceCallTempList(props.global, status).then(response => {
            setLoading(false);
            if (response.success) {
                setSvcTemps(response.svcCallTemplates);
                //setTimeUnits(response.svcTimeUnits);
                setStatuses(response.svcStatuses);
                //setScheduleUnits(response.scheduleUnits);
                //setCanAdd(response.canAddEdit);
            }
        }).catch(() => {
            setLoading(false);
        })
    }, [props.global, status])
    return (
        <div className="pools-table-container">
            {loading && <Loader />}
            <div className="button-container">
                <Link to="/ServiceTemps/new" className="button">
                    <i className="fa-solid fa-circle-plus"></i> Add New Template
                </Link>
                <select className="select" value={status}
                    onChange={(e) => setStatus(e.target.value)}>
                    <option value={-1}>-- Select a Status --</option>
                    {statuses.map(s =>
                        <option key={s.svcStatusID} value={s.svcStatusID}>
                            {s.svcStatusName}
                        </option>
                    )}
                </select>
            </div>
            <table className="pools-table">
                <tbody>
                    <tr>
                        <th>Service Template Name</th>
                        <th>Status</th>
                    </tr>
                    {svcTemps.length === 0 && (
                        <tr>
                            <td colSpan="2"><i>No Task Templates Found.</i></td>
                        </tr>
                    )}
                    {status !== -1 && (
                        svcTemps.filter(st => st.statusID === status).map(t =>
                            <tr key={t.svcTempID}>
                                <td>
                                    <Link to={`/ServiceTemps/${t.svcTempID}`}>
                                        {t.svcTempName}
                                    </Link>
                                </td>
                                <td>
                                    {t.statusName}
                                </td>
                            </tr>
                        )
                    )}
                    {svcTemps.map(t =>
                        <tr key={t.svcTempID}>
                            <td>
                                <Link to={`/ServiceTemps/${t.svcTempID}`}>
                                    {t.svcTempName}
                                </Link>
                            </td>
                            <td>
                                {t.statusName}
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    )
}
export default ServiceTempList;